









import { defineComponent } from '@nuxtjs/composition-api';
import urlJoin from 'url-join';
import { useRuntimeConfig } from '~/composables/useRuntimeConfig';
import { useStore } from '~/composables/useStore';
import { url } from '~/utils';
import { sendLoginEvent as sendEvent } from '~/utils/ga';
import { LoginCategory, LoginStatus } from '~/enums/login';

export default defineComponent({
  setup() {
    const { AMAZON_PUBLIC_KEY, ENABLED_AMAZON_PAY_SANDBOX } = useRuntimeConfig();
    const store = useStore();

    const onClickAmazonButton = () => {
      sendEvent(LoginStatus.TRIED, LoginCategory.AMAZON);
      localStorage.setItem('loginCategory', LoginCategory.AMAZON);
    };

    const initAmazonPay = async () => {
      const sessionPayload = {
        signInReturnUrl: urlJoin(window.location.origin, url('LOGIN_WITH_AMAZON')),
        storeId: 'amzn1.application-oa2-client.d52e7d62167d47c7bfee4d758179dce9',
        signInScopes: ['name', 'email', 'postalCode', 'shippingAddress', 'billingAddress', 'phoneNumber'],
      };

      const { signature } = await store.dispatch('modules/amazonPay/getAmazonSignature', {
        data: JSON.stringify(sessionPayload),
      });

      window.amazon.Pay.renderButton('#AmazonPayButton', {
        merchantId: 'A30308P7UT5IRJ',
        ledgerCurrency: 'JPY',
        sandbox: ENABLED_AMAZON_PAY_SANDBOX === 'enabled',
        checkoutLanguage: 'ja_JP',
        productType: 'SignIn',
        placement: 'Cart',
        buttonColor: 'Gold',
        signInConfig: {
          payloadJSON: sessionPayload,
          signature,
          publicKeyId: AMAZON_PUBLIC_KEY,
        },
      });
    };

    return {
      onClickAmazonButton,
      initAmazonPay,
    };
  },
});
